import type { GraphExportData } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';

export const exportGraphWithoutHiddenElements = (
  graph: GraphData,
): GraphExportData => ({
  boxLabels: graph.boxLabels,
  nodes: pipe(
    graph.nodes,
    record.filter((node) => !graph.hiddenNodes.has(node.id)),
  ),
  edges: pipe(
    graph.edges,
    record.filter(
      (edge) =>
        !(
          graph.hiddenNodes.has(edge.source) ||
          graph.hiddenNodes.has(edge.target)
        ),
    ),
  ),
});
